import { tv } from 'tailwind-variants'

import { typography } from '@gto/ui/typography'

export const groupedFieldVariants = tv({
  slots: {
    root: 'group/grouped-field m-0 min-w-0 border-0 p-0',
    legend: [
      typography['input/label'],
      'mb-0.5 flex min-h-4 w-full items-center gap-1 px-2 text-text-secondary transition-colors',
      'group-has-[:focus-visible]/grouped-field:text-primary-main',
      'group-has-[[aria-invalid=true]]/grouped-field:text-error-main',
      'group-data-[invalid=true]/grouped-field:text-error-main',
      'group-disabled/grouped-field:text-text-disabled',
    ],
    controls: 'flex min-w-0',
    description: 'px-2 text-[10px] leading-[166%] tracking-[0.4px] text-text-secondary',
    error: 'px-2 text-[10px] leading-[166%] tracking-[0.4px] text-error-main',
  },
  variants: {
    orientation: {
      horizontal: {
        controls: 'flex-row items-start',
      },
      vertical: {
        controls: 'flex-col',
      },
    },
    gap: {
      small: {
        controls: 'gap-1',
      },
      medium: {
        controls: 'gap-2',
      },
      large: {
        controls: 'gap-3',
      },
    },
  },
  defaultVariants: {
    orientation: 'horizontal',
    gap: 'small',
  },
})
